import { ReadonlySignal } from '@preact/signals-react';

export abstract class AuthState {
  abstract readonly authenticated: ReadonlySignal<boolean>;
  abstract readonly email: ReadonlySignal<string>;

  abstract setOwnerEmail(email: string): void;
  abstract reset(): void;
}
